export const philippinesPrimaryColor = "#7aaede"
export const philippinesPrimaryColorDarker = "#2f7bc0"
